import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { getCurrentUser, fetchUserAttributes } from '@aws-amplify/auth';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import AdminProtectedRoute from './components/AdminProtectedRoute';

const AdminApp = () => {
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    checkAdminStatus();
  }, []);

  const checkAdminStatus = async () => {
    try {
      await getCurrentUser();
      const attributes = await fetchUserAttributes();
      const userType = attributes['custom:userType'];
      setIsAdmin(userType === 'admin');
    } catch (error) {
      setIsAdmin(false);
    }
  };

  if (isAdmin === null) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route element={<AdminProtectedRoute isAuthPage={true} />}>
          <Route path="/login" element={<AdminLogin />} />
        </Route>

        <Route element={<AdminProtectedRoute isAuthPage={false} />}>
          <Route path="/dashboard/*" element={<AdminDashboard />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
};

export default AdminApp;